// @flow
export const filterId: 'customerSearch' = 'customerSearch';
